import axiosProvider from "../../utils/axios-provider/axios-provider";
import { AUTHORIZATION_HEADER } from "../../../constants";

// Actions
export const DATA_RETENTION_BUTTON_CLICKED =
  "create/DATA_RETENTION_BUTTON_CLICKED";
export const CREATE_PERSONAL_USER_REQUEST =
  "create/CREATE_PERSONAL_USER_REQUEST";
export const CREATE_PERSONAL_USER_SUCCESS =
  "create/CREATE_PERSONAL_USER_SUCCESS";
export const CREATE_PERSONAL_USER_FAILURE =
  "create/CREATE_PERSONAL_USER_FAILURE";
export const FETCH_CONFIGURATION_SUCCESS = "create/FETCH_CONFIGURATION_SUCCESS";
export const FETCH_CONFIGURATION_FAILURE = "create/FETCH_CONFIGURATION_FAILURE";

// Reducer
export const initialState = {
  loading: true,
  error: null,
  createUserSucess: false,
  isSocialEnabled: false,
  isCoppa: false,
  fetchConfigError: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_PERSONAL_USER_REQUEST:
      return { ...state, error: null, loading: true };
    case CREATE_PERSONAL_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        createUserSucess: true
      };
    case CREATE_PERSONAL_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case FETCH_CONFIGURATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isSocialEnabled:
          action.payload.isSocialEnabled || action.payload.socialEnabled,
        fetchConfigError: null
      };
    case FETCH_CONFIGURATION_FAILURE:
      return {
        ...state,
        fetchConfigError: action.payload,
        isSocialEnabled: false,
        isCoppa: false
      };
    default:
      return state;
  }
}

// Action Creators
export const createPersonalUserRequest = () => ({
  type: CREATE_PERSONAL_USER_REQUEST
});

export const createPersonalUserSuccess = () => ({
  type: CREATE_PERSONAL_USER_SUCCESS
});

export const createPersonalUserFailure = error => ({
  type: CREATE_PERSONAL_USER_FAILURE,
  payload: error
});

export const fetchConfiguration = ({
  baseUrl,
  custId,
  groupId,
  profileId,
  authToken
}) => async dispatch => {
  const headers = {};

  if (authToken) {
    headers[AUTHORIZATION_HEADER] = `Bearer ${authToken}`;
  }

  const url = `${baseUrl}/v2/config/customers/${custId}/groups/${groupId}/profiles/${profileId}`;

  try {
    const { data } = await axiosProvider.getInstance().get(url, {
      headers
    });
    dispatch({ type: FETCH_CONFIGURATION_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_CONFIGURATION_FAILURE,
      payload: error
    });
  }
};

export const getIsSocialAuthEnabled = state =>
  Boolean(state.create.isSocialEnabled);

export const getIsCoppa = state => Boolean(state.create.isCoppa);

export const getConfigError = state =>
  state.create.fetchConfigError ? state.create.fetchConfigError : null;
